<template>
  <div class="user-teacher-area">

    <div class="add-class">
      <h2>Clases de alumnos</h2>
      <p>Aquí puedes ver las clases que gestionas como profesor</p>
      <button class = "btn btn-bg-colored btn-no-margin" v-on:click="showAddClassroom()">
        Añadir nueva clase
      </button>
    </div>

    <div class = "classrooms">
      <ClassroomDetail
        v-for="classroom in myUserInfo.owns_classrooms"
        :key="classroom.id"
        :classroom = "classroom" />
    </div>

    <b-modal :active.sync="editorConfig.isShowingNewClassroom" >
      <new-classroom></new-classroom>
    </b-modal>
  </div>
</template>

<script>
import NewClassroom from './NewClassroom'
import ClassroomDetail from './ClassroomDetail'

export default {
  name: 'UserTeacherArea',
  props: {},
  components: {
    NewClassroom,
    ClassroomDetail
  },
  computed: {
    myUserInfo () {
      return this.$store.state.user.userInfo
    },
    editorConfig () {
      return this.$store.state.editorConfig
    },
    getUserProjects () {
      return this.userProjects
    }
  },
  data: () => ({
  }),
  methods: {
    loadTeacherClassData: function () {
      this.$store.dispatch('user/fetchUserInfo')
        .then(() => {
          // if I am teacher get all projects shared with me
          this.$store.state.user.userInfo.owns_classrooms.forEach((classroom) => {
            this.$store.dispatch('user/teacher_fetchProjectsSharedWithMe', classroom.id)
          })
        })
    },
    closeNewClassroomAndRefresh: function () {
      this.loadTeacherClassData()
    },
    showAddClassroom: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingNewClassroom': true})
    }
  },
  created () {
    this.loadTeacherClassData()
  }
}

</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

.user-teacher-area {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;

  & > div {
    padding: 20px;
  }
}

.classrooms {
  flex: 3;
}

.add-class {
  flex: 2;

  p {
    margin-bottom: 15px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/User/UserTeacherArea.vue